// @flow

export type CampaignDashboardQueryData = {
  page: number;
  salesmanReference?: string;
}

export default class CampaignDashboardQuery {
  page: number;
  salesmanReference: void | string;

  constructor({ page, salesmanReference }: CampaignDashboardQueryData) {
    this.page = page;
    this.salesmanReference = salesmanReference;
  }

  asQueryParams() {
    return {
      page: this.page,
      perPage: 5,
      salesman: this.salesmanReference,
    };
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/domain/CampaignDashboardQuery.js